import { jsError } from "../../common/utils";

/** Display a single file inside a modal with filename and download link
 * @param {Promise<Response>} fetchPromise - Fetch Response Promise
 */
export async function fileLink(fetchPromise, fileName) {

  const res = await fetchPromise;
  try {
    if (res.status === 200) {
      const a = document.createElement("a");
      if (fileName) {
        a.download = fileName;
      }
      else {
        const disposition = res.headers.get("content-disposition");
        if (disposition) {
          const filename = disposition.match(/filename="(.+)"$/);
          if (filename !== null) {
            a.download = decodeURIComponent(filename[1]);
          }
        }
      }

      const href = URL.createObjectURL( await res.blob() );
      a.href = href;
      a.target = "_blank";
      a.click();
      setTimeout(URL.revokeObjectURL, 0, href); // release reference to the file
    }
  }
  catch (error) {
    jsError(error);
  }

}
